import {useQuery} from "react-query";
import ApiClient from "../../API";
import {useResolvedPath} from "react-router-dom";

export function useBroadcastPermissions() {
    const data = useQuery({
        queryKey: ['broadcast_permissions'],
        queryFn: () => {
            return ApiClient().get('broadcast/permissions/', {}).then(res => res.data)
        },
        refetchOnWindowFocus: true,
        refetchOnMount: false,
        refetchOnReconnect: false,
        placeholderData: {
            can_add: false,
            can_edit: false,
            can_delete: false,
            can_view: true,
        }
    })

    return {
        canAdd: data.data?.can_add || false,
        canEdit: data.data?.can_edit || false,
        canDelete: data.data?.can_delete || false,
        canView: data.data?.can_view || true,
        isLoading: data.isLoading,
    }
}

export function useBroadcastNotifications() {
    const data = useQuery({
        queryKey: ['broadcast_notifications'],
        queryFn: () => {
            return ApiClient().get('broadcast/', {}).then(res => res.data)
        },
        refetchOnWindowFocus: true,
        refetchOnMount: true,
        refetchOnReconnect: true,
        placeholderData: []
    })

    const currentPath = useResolvedPath()
    const filteredNotifications = data.data?.filter(notification => {
        return !notification.location_tags || notification.location_tags.length === 0 ||
            notification.location_tags.includes(currentPath.pathname)
    }) || [];

    return {
        notifications: filteredNotifications || [],
        isLoading: data.isLoading,
    }
}